<h2 mat-dialog-title>
  {{'move' | translate}} {{ data.member.firstname }} {{ data.member.lastname }}
  {{'in_another_team' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-15">
  @if (data.teams.length > 0) {
    <div>
      <p class="pb-2 text-start">{{'select_destination_team' | translate}}:</p>
      <mat-form-field>
        <mat-select [formControl]="teamCtrl">
          <mat-select-trigger>
            {{teamCtrl.value?.name || ''}}
          </mat-select-trigger>
          @for (team of data.teams; track team) {
            <mat-option [value]="team">{{team.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (data.teams.length === 0) {
    <div>
      <p class="py-2">
        {{'move_error' | translate}} {{data.member.firstname}}
        {{data.member.lastname}}.
      </p>
      <em>{{ error | translate }}</em>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>

  <button type="button"
    class="btn btn-default"
    mat-dialog-close>{{'cancel' | translate}}
  </button>
  <button [disabled]="!teamCtrl.value"
    type="button"
    class="btn btn-primary"
    (click)="moveMember()">{{'move' | translate}}
  </button>

</mat-dialog-actions>